import { EvidenceItem } from "./Evidence";

export const activityDataOrderByKeys = [
    "ActivityDate",
    "LocationName",
    "DataSourceName",
    "Scope",
] as const;

export type ActivityDataOrderBy = (typeof activityDataOrderByKeys)[number];

export const isActivityDataOrderBy = (
    value: string
): value is ActivityDataOrderBy => {
    return activityDataOrderByKeys.includes(value as ActivityDataOrderBy);
};

export type AddActivityDataDto = {
    rawActivityQuantity: number;
    activityStartDate: string;
    activityEndDate: string;
};

export type ActivityData = {
    id: number;
    rawUnitsSuffix: string;
    rawUnitsSuffixHtml: string;
    rawMaterialName: string;
    locationName: string;
    emissionsSourceId: number;
    dataSourceId: number;
    dataSourceName: string;
    activityStartDate: string;
    activityEndDate: string;
    rawActivityQuantity: number;
    scope: number;
    conversionFactor: number;
    co2e?: number;
    normalizedActivityQuantity: number;
    normalizedUnitsSuffix: string;
    normalizedUnitsSuffixHtml: string;
    emissionsFactors: ActivityDataEmissionsFactor[];
    carbonCalculations: CarbonCalculation[];
    submittedAt: string;
};

export type ActivityDataDetail = {
    emissionsSourceEvidence: EvidenceItem[];
    createdByUserDisplayName?: string;
} & ActivityData;

export type ActivityDataEmissionsFactor = {
    emissionsFactor?: number;
    calculationLastSetAt?: string;
};

export type ActivityDataUnit = {
    id: number;
    suffix: string;
};

export type ActivityDataRawMaterial = {
    id: number;
    name: string;
};

export type CarbonCalculation = {
    startDate: string;
    endDate: string;
    emissionFactor: number;
    conversionFactor: number;
    rawActivityQuantity: number;
    normalizedActivityQuantity: number;
    cO2e: number;
}